module.exports = __webpack_public_path__ + "img/logo.72877305.png";